import React, { useState } from "react";
import { Col, NavbarBrand } from "reactstrap";
import { T } from "../../traks";
import { Input } from "../../c/Input";
import { RenderIf } from "../../helpers/RenderIf";
import { LL } from "../../c/LL";

const ForgotPassword = ({ preSetUsername, sendEmail, setForgotPw, forgotPwSent }) => {
	const [username, setUsername] = useState(preSetUsername)
	return (
		<div className="d-flex flex-column justify-content-md-between w-100 vh-100">
			<div className="pt-3 pt-lg-5 mb-md-0 mb-5">
				<NavbarBrand href={LL("/")}>
					<img src='https://static.sibilus.eu/gfx/pentus-logo-0.svg' width="120px" alt='our logo' />
				</NavbarBrand>
			</div>
			<Col xs={12} lg={6} className="mx-auto mt-5 mt-md-0">
				<div className="text-start pb-3 px-1 font_14px">
					<T>Enter your username (email). If an account exists in our system, a reset password link will be emailed to you.</T>
				</div>
				<form onSubmit={(e) => e.preventDefault()} className="w-100">
					<Input
						rounded
						className="pt-2 w-100 border_radius_6px"
						initValue={preSetUsername}
						dataCy="username"
						placeholder={<T>Username</T>}
						type="email"
						onChange={(username) => setUsername(username)}
					/>
					<button
						className="text-white font_15px btn btn_green w-100 mt-4"
						disabled={username.length === 0}
						onClick={(e) => {
							e.preventDefault();
							sendEmail(username);
						}}
					>
						<T>Reset Password</T>
					</button>
				</form>
				<RenderIf condition={forgotPwSent}>
					<div className="mt-5 fw_700">
						<T>An email has been sent. Please check your mail!</T>
					</div>
				</RenderIf>
			</Col>
			<div className="pb-5 cursor_pointer">
				<div onClick={() => setForgotPw(false)}><span className="me-3"><T>Back to login?</T></span><span className="link_nostyle fw_600 primary"><T>Login</T></span></div>
			</div>
		</div>
	)
}

export { ForgotPassword }
